module.exports = __webpack_public_path__ + "static/media/menu-flows.16895a48.svg";